import config from "config/appConfig";

import type { IStateProps } from "utils/StateOf";
import createStoreFunction from "utils/createStore";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.AUTH_DATA}`;

export interface Values {
	loading: boolean;

	checkingResetPasswordCode: boolean;
}

export const initialState: IStateProps<Values> = {
	loading: false,

	checkingResetPasswordCode: false
};

export default createStoreFunction<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
